module.exports = __webpack_public_path__ + "images/illustrations/illustration-storyline3@1x-447802f55f03de1daa690b15138d62fd.webp";